import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Tooltip from '@src/components/Tooltip';
import CrownIcon from '@src/assets/icons/icon-crown.svg';
import useUserInfo from '@src/hooks/useTtsUser';
import { getUpgradePackageLabelKey } from '@src/services/voice';
import { LimitedFeatureContainer } from './index.style';

const LimitedFeature = ({ voiceFeatures = [], isTooltip = true, tooltip }) => {
  const { ttsUser } = useUserInfo();
  const allPackages = useSelector((state) => state.packages.packages);
  const { t } = useTranslation();

  const getTooltipText = useMemo(() => {
    if (tooltip) return tooltip;

    if (!voiceFeatures || !voiceFeatures.length) return '';

    const hasMissingFeature = voiceFeatures.some(
      (feature) => !ttsUser?.features?.includes(feature),
    );
    if (!hasMissingFeature) return '';

    const packageName = t(
      getUpgradePackageLabelKey({
        voiceFeatures,
        userFeatures: ttsUser?.features,
        packages: allPackages,
      }),
    );

    return t('voiceTrialLimitTooltip', { packageName });
  }, [voiceFeatures, ttsUser?.features, tooltip, allPackages, t]);

  if (!voiceFeatures?.length || !getTooltipText) return null;

  return (
    <LimitedFeatureContainer>
      <Tooltip
        title={getTooltipText}
        placement="top"
        arrow
        disableInteractive
        disableHoverListener={!getTooltipText || !isTooltip}
      >
        <div className="limited-feature-icon">
          <img src={CrownIcon} alt="limited-feature" />
        </div>
      </Tooltip>
    </LimitedFeatureContainer>
  );
};

export default LimitedFeature;
